import * as React from 'react';
export const GFSvg = React.forwardRef(function GFSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M14 2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M2 14h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2ZM1 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M2 2c-.51 0-.975.19-1.328.504l14.656 10.992c.412-.366.672-.9.672-1.496V4a2 2 0 0 0-2-2H2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        fillRule: 'nonzero',
        d: 'm10.755 7-1.75.004a.243.243 0 0 1-.231-.168L8.232 5.17a.243.243 0 0 0-.464 0l-.54 1.664a.243.243 0 0 1-.231.168H5.246a.243.243 0 0 0-.143.441l1.415 1.03a.243.243 0 0 1 .089.272l-.54 1.665a.243.243 0 0 0 .375.272l1.415-.95a.243.243 0 0 1 .287 0l1.416.95a.243.243 0 0 0 .376-.272l-.542-1.665a.243.243 0 0 1 .088-.273l1.416-1.029A.246.246 0 0 0 10.755 7Z',
      }),
    ),
  );
});
GFSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var GF = {
  category: 'flag',
  colorable: false,
  name: 'GF',
  svg: GFSvg,
};
